export const SortIcon = ({
  colour,
  activeColour,
  isAsc = false,
}: {
  colour: string;
  activeColour?: string;
  isAsc?: boolean;
}) => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      xmlns="http://www.w3.org/2000/svg"
      fill={colour}
    >
      <path
        d="M4.39043 11.512C4.19027 11.7622 3.80973 11.7622 3.60957 11.512L0.649878 7.81235C0.387973 7.48497 0.621059 7 1.04031 7H6.95969C7.37894 7 7.61203 7.48497 7.35012 7.81235L4.39043 11.512Z"
        fill={isAsc ? activeColour : ""}
      />
      <path
        d="M4.39043 0.488043C4.19027 0.23784 3.80973 0.23784 3.60957 0.488043L0.649878 4.18765C0.387973 4.51503 0.621059 5 1.04031 5H6.95969C7.37894 5 7.61203 4.51503 7.35012 4.18765L4.39043 0.488043Z"
        fill={!isAsc ? activeColour : ""}
      />
    </svg>
  );
};
